import { PageTitle } from 'app/components/common/PageTitle'
import ActivityEngagementManagementContainer from 'app/containers/ActivityEngagement'
import { isEqual } from 'lodash'
import { memo } from 'react'

const ActivityEngagementManagementCpn = () => {
  return (
    <>
      <PageTitle>{'Quản lý tình trạng sinh hoạt'}</PageTitle>
      <ActivityEngagementManagementContainer />
    </>
  )
}
export const ActivityEngagementManagementPage = memo(
  ActivityEngagementManagementCpn,
  isEqual,
)
